import { z } from "zod";
export const NonEmpty = z.string().min(1);
export const Id = z.string().min(1, "Id is required!");
export const Url = z.url();
